<div data-test-id="wiedervorlage-datum">Datum der Wiedervorlage {{wiedervorlageDatum | formatDate }}</div>
